import { makeStyles } from "@material-ui/core/styles";

export const useStyle = makeStyles({
  default: {
    padding: ".125rem .25rem",
    fontSize: ".8rem",
    color: "rgba(0,0,0,.65)",
    backgroundColor: "#fafafa",
    border: "1px solid #d9d9d9",
    cursor: "pointer",
  },
  processing: {
    padding: ".125rem .25rem",
    fontSize: ".8rem",
    color: "#1890ff",
    backgroundColor: "#e6f7ff",
    border: "1px solid #91d5ff",
    cursor: "pointer",
  },
  success: {
    padding: ".125rem .25rem",
    fontSize: ".8rem",
    color: "#52c41a",
    backgroundColor: "#f6ffed",
    border: "1px solid #b7eb8f",
    cursor: "pointer",
  },
  waiting: {
    padding: ".125rem .25rem",
    fontSize: ".8rem",
    color: "#fa8c16",
    backgroundColor: "#fff7e6",
    border: "1px solid #ffd591",
    cursor: "pointer",
  },
  waiting_user: {
    padding: ".125rem .25rem",
    fontSize: ".8rem",
    color: "#fa8c16",
    backgroundColor: "#fff7e6",
    border: "1px solid #ffd591",
    cursor: "pointer",
  },
  error: {
    padding: ".125rem .25rem",
    fontSize: ".8rem",
    color: "#f5222d",
    backgroundColor: "#fff1f0",
    border: "1px solid #ffa39e",
    cursor: "pointer",
  },
  warning: {
    padding: ".125rem .25rem",
    fontSize: ".8rem",
    color: "#e8a307",
    backgroundColor: "#fff8f0",
    border: "1px solid #e8a307",
    cursor: "pointer",
  },
});
